var __jsx = React.createElement;
import React, { useState } from 'react';
import { useLang } from '@/common/Contexts/LanguageContext';
import { Icon } from '@syarahtech/ui';
import { useTranslation } from '@i18n';
var FAQSection = function FAQSection(_ref) {
  var _all$cheapest, _all$cheapest$car, _all$cheapest2, _all$most_expensive, _all$most_expensive2, _all$most_expensive2$, _all$cheapest3, _all$cheapest3$car, _all$cheapest4, _filters$car_shape_id, _filters$car_shape_id2, _filters$car_shape_id3, _filters$car_shape_id4, _filters$car_shape_id5, _filters$drivetrain_t, _filters$drivetrain_t2, _filters$drivetrain_t3, _filters$drivetrain_t4, _filters$drivetrain_t5, _filters$make_country, _filters$make_country2, _filters$make_country3, _filters$make_country4, _filters$make_country5, _all$most_expensive3, _all$most_expensive3$, _all$most_expensive4;
  var carPriceInsights = _ref.carPriceInsights;
  var lang = useLang();
  var _useState = useState(0),
    activeFaqIndex = _useState[0],
    setActiveFaqIndex = _useState[1];
  var _useTranslation = useTranslation(['car_prices']),
    tShort = _useTranslation.tShort;
  var toggleFaq = function toggleFaq(index) {
    setActiveFaqIndex(activeFaqIndex === index ? -1 : index);
  };
  var titleKey = lang === 'ar' ? 'title_ar' : 'title_en';
  var brandKey = lang === 'ar' ? 'brand_ar' : 'brand_en';
  var all = carPriceInsights === null || carPriceInsights === void 0 ? void 0 : carPriceInsights.all;
  var filters = carPriceInsights === null || carPriceInsights === void 0 ? void 0 : carPriceInsights.filters;
  var faqs = [{
    question: tShort('cheapest_cars_question', {
      ns: 'car_prices'
    }),
    answer: tShort('cheapest_car_answer', {
      ns: 'car_prices',
      name: all === null || all === void 0 ? void 0 : (_all$cheapest = all.cheapest) === null || _all$cheapest === void 0 ? void 0 : (_all$cheapest$car = _all$cheapest.car) === null || _all$cheapest$car === void 0 ? void 0 : _all$cheapest$car[titleKey],
      price: all === null || all === void 0 ? void 0 : (_all$cheapest2 = all.cheapest) === null || _all$cheapest2 === void 0 ? void 0 : _all$cheapest2.price
    })
  }, {
    question: tShort('highest_price_question', {
      ns: 'car_prices'
    }),
    answer: tShort('highest_price_answer', {
      ns: 'car_prices',
      price: all === null || all === void 0 ? void 0 : (_all$most_expensive = all.most_expensive) === null || _all$most_expensive === void 0 ? void 0 : _all$most_expensive.price,
      name: all === null || all === void 0 ? void 0 : (_all$most_expensive2 = all.most_expensive) === null || _all$most_expensive2 === void 0 ? void 0 : (_all$most_expensive2$ = _all$most_expensive2.car) === null || _all$most_expensive2$ === void 0 ? void 0 : _all$most_expensive2$[titleKey]
    })
  }, {
    question: tShort('price_factors_question', {
      ns: 'car_prices'
    }),
    answer: tShort('price_factors_answer', {
      ns: 'car_prices'
    })
  }, {
    question: tShort('cheapest_brands_question', {
      ns: 'car_prices'
    }),
    answer: tShort('cheapest_brands_answer', {
      ns: 'car_prices',
      brand: all === null || all === void 0 ? void 0 : (_all$cheapest3 = all.cheapest) === null || _all$cheapest3 === void 0 ? void 0 : (_all$cheapest3$car = _all$cheapest3.car) === null || _all$cheapest3$car === void 0 ? void 0 : _all$cheapest3$car[brandKey],
      price: all === null || all === void 0 ? void 0 : (_all$cheapest4 = all.cheapest) === null || _all$cheapest4 === void 0 ? void 0 : _all$cheapest4.price
    })
  }, {
    question: tShort('cheapest_sedan_question', {
      ns: 'car_prices'
    }),
    answer: tShort('cheapest_sedan_answer', {
      ns: 'car_prices',
      price: filters === null || filters === void 0 ? void 0 : (_filters$car_shape_id = filters.car_shape_id) === null || _filters$car_shape_id === void 0 ? void 0 : (_filters$car_shape_id2 = _filters$car_shape_id.cheapest) === null || _filters$car_shape_id2 === void 0 ? void 0 : _filters$car_shape_id2.price,
      name: filters === null || filters === void 0 ? void 0 : (_filters$car_shape_id3 = filters.car_shape_id) === null || _filters$car_shape_id3 === void 0 ? void 0 : (_filters$car_shape_id4 = _filters$car_shape_id3.cheapest) === null || _filters$car_shape_id4 === void 0 ? void 0 : (_filters$car_shape_id5 = _filters$car_shape_id4.car) === null || _filters$car_shape_id5 === void 0 ? void 0 : _filters$car_shape_id5[titleKey]
    })
  }, {
    question: tShort('cheapest_suv_question', {
      ns: 'car_prices'
    }),
    answer: tShort('cheapest_suv_answer', {
      ns: 'car_prices',
      price: filters === null || filters === void 0 ? void 0 : (_filters$drivetrain_t = filters.drivetrain_type_id) === null || _filters$drivetrain_t === void 0 ? void 0 : (_filters$drivetrain_t2 = _filters$drivetrain_t.cheapest) === null || _filters$drivetrain_t2 === void 0 ? void 0 : _filters$drivetrain_t2.price,
      name: filters === null || filters === void 0 ? void 0 : (_filters$drivetrain_t3 = filters.drivetrain_type_id) === null || _filters$drivetrain_t3 === void 0 ? void 0 : (_filters$drivetrain_t4 = _filters$drivetrain_t3.cheapest) === null || _filters$drivetrain_t4 === void 0 ? void 0 : (_filters$drivetrain_t5 = _filters$drivetrain_t4.car) === null || _filters$drivetrain_t5 === void 0 ? void 0 : _filters$drivetrain_t5[titleKey]
    })
  }, {
    question: tShort('cheapest_chinese_question', {
      ns: 'car_prices'
    }),
    answer: tShort('cheapest_chinese_answer', {
      ns: 'car_prices',
      price: filters === null || filters === void 0 ? void 0 : (_filters$make_country = filters.make_country) === null || _filters$make_country === void 0 ? void 0 : (_filters$make_country2 = _filters$make_country.cheapest) === null || _filters$make_country2 === void 0 ? void 0 : _filters$make_country2.price,
      name: filters === null || filters === void 0 ? void 0 : (_filters$make_country3 = filters.make_country) === null || _filters$make_country3 === void 0 ? void 0 : (_filters$make_country4 = _filters$make_country3.cheapest) === null || _filters$make_country4 === void 0 ? void 0 : (_filters$make_country5 = _filters$make_country4.car) === null || _filters$make_country5 === void 0 ? void 0 : _filters$make_country5[titleKey]
    })
  }, {
    question: tShort('most_expensive_brands_question', {
      ns: 'car_prices'
    }),
    answer: tShort('most_expensive_brands_answer', {
      ns: 'car_prices',
      brand: all === null || all === void 0 ? void 0 : (_all$most_expensive3 = all.most_expensive) === null || _all$most_expensive3 === void 0 ? void 0 : (_all$most_expensive3$ = _all$most_expensive3.car) === null || _all$most_expensive3$ === void 0 ? void 0 : _all$most_expensive3$[brandKey],
      price: all === null || all === void 0 ? void 0 : (_all$most_expensive4 = all.most_expensive) === null || _all$most_expensive4 === void 0 ? void 0 : _all$most_expensive4.price
    })
  }, {
    question: tShort('price_difference_question', {
      ns: 'car_prices'
    }),
    answer: tShort('price_difference_answer', {
      ns: 'car_prices'
    })
  }, {
    question: tShort('price_update_question', {
      ns: 'car_prices'
    }),
    answer: tShort('price_update_answer', {
      ns: 'car_prices'
    })
  }];
  return /*#__PURE__*/React.createElement("section", {
    id: "faq-section",
    className: "my-4 md:my-20 px-5 md:px-4"
  }, /*#__PURE__*/React.createElement("div", {
    id: "faq-container",
    className: "mx-auto md:max-w-[1200px]"
  }, /*#__PURE__*/React.createElement("h2", {
    id: "faq-title",
    className: "text-center text-primary-old font-bold md:text-[32px] text-2xl mt-10 mb-6 md:mb-10"
  }, tShort('faq_title', {
    ns: 'car_prices'
  })), /*#__PURE__*/React.createElement("div", {
    id: "faq-items-container",
    className: "space-y-4"
  }, faqs.map(function (faq, index) {
    return /*#__PURE__*/React.createElement("div", {
      id: "faq-item-".concat(index),
      className: "border-[1px] border-solid border-[#D6DFE9] rounded-lg overflow-hidden",
      key: index,
      onClick: function onClick() {
        return toggleFaq(index);
      }
    }, /*#__PURE__*/React.createElement("div", {
      id: "faq-item-header-".concat(index),
      className: "flex justify-between ".concat(activeFaqIndex === index ? 'items-start' : 'items-center', " gap-2 p-5 sm:p-4 cursor-pointer transition-all duration-300 ease-in-out")
    }, /*#__PURE__*/React.createElement("span", {
      id: "faq-item-question-".concat(index),
      className: "text-4 sm:text-3 sm:line-height-6 font-bold text-primary-old text-right rtl:text-right ltr:text-left leading-7"
    }, faq.question), /*#__PURE__*/React.createElement("span", {
      id: "faq-item-toggle-icon-".concat(index),
      className: "flex items-center justify-center text-primary-old shrink-0 w-6 h-6"
    }, activeFaqIndex === index ? /*#__PURE__*/React.createElement(Icon, {
      width: 6,
      height: 6,
      icon: "material-symbols--keyboard-arrow-up-rounded"
    }) : /*#__PURE__*/React.createElement(Icon, {
      width: 6,
      height: 6,
      icon: "material-symbols--keyboard-arrow-down-rounded"
    }))), /*#__PURE__*/React.createElement("div", {
      id: "faq-item-answer-".concat(index),
      className: "p-[0_20px_20px] text-4 sm:text-3 sm:line-height-4 leading-[1.6] text-[#6B7EA5] text-right rtl:text-right ltr:text-left ".concat(activeFaqIndex !== index ? 'hidden' : '')
    }, faq.answer));
  }))));
};
export default FAQSection;